/** @summary params傳入欲尋找的sessionStorage的Key
 * @param ssKey 欲尋找的key
 * @returns 有參數回傳key值
 */
export const getSessionStorageKeyVal = (ssKey: string) => {
    return window.sessionStorage.getItem(ssKey);
};

/** @summary 將價格數字每三位數加逗號
 * @param price 輸入需轉換的數字
 * @returns 數字string 1,000,000
 */
export const formatPrice = (price: number) => {
    return new Intl.NumberFormat().format(price);
};

/** @summary 將文案限制顯示上限字數
 * @param text 需判斷的文案
 * @param limitLength 設定上限字數量
 * @returns 超過設定數量則會擷取後在最後接上 "..."
 */
export const limitTextLength = (text: string, limitLength: number) => {
    if (text.length > limitLength) return `${text.slice(0, limitLength)}...`;
    return text;
};

/** @summary 將seo網址參數 sort、taglist等，根據redux狀態更動location.search而不跳頁reload
 * @param seo_sort 給seo的sort英文代碼，不是api的數字，參考FilterWithSort裡的預設
 * @param TagList 館別頁籤
 * @return void 未給參數 不更動網址參數
 */
export const changeSeoParams = (
    seo_sort: string | null | number,
    TagList: string | null | number
) => {
    const urlString = location.search;
    if ((seo_sort === null && TagList === null) || urlString === '') return;
    const urlArr = urlString.split('&');
    urlArr.forEach((val, key) => {
        if (seo_sort && val.includes('sort')) urlArr[key] = 'sort=' + seo_sort;
        if (TagList && val.includes('taglist')) urlArr[key] = 'taglist=' + TagList;
    });

    urlArr[0] = urlArr[0].replace(/\?/, ''); // 陣列第一個若有問號則全部移除，下方之後補上

    window.history.replaceState({}, document.title, location.pathname + '?' + urlArr.join('&'));
};

/** @summary 將XX:XX時間格式轉為XX小時XX分鐘格式
 * @param time 需判斷的時間
 * @returns 3小時30分鐘
 */
export const timeTransform = (time: string) => {
    const splitTime = time.split(':');
    const splitHour = splitTime[0] === '00' || splitTime[0] === '0' ? '' : splitTime[0];
    const splitMin = splitTime[1] === '00' || splitTime[1] === '0' ? '' : splitTime[1];
    const hour = splitHour ? splitHour + '小時' : '';
    const min = splitMin ? splitMin + '分鐘' : '';
    return hour + min;
};

// 多層checkbox重組格式用
// parentName -> 分類最上層項目
// parentID -> 最上層checkbox的id
// childName -> 子項目名稱(標籤)
// childID -> 子項目ID(值)

enum MutiCheckboxKeys {
    // 目的地參數
    CityID = 'CityID',
    CityName = 'CityName',
    CountryID = 'CountryID',
    CountryName = 'CountryName',
    // 票券->所有商品類別
    ParentID = 'ParentID',
    ParentName = 'ParentName',
    Kind = 'Kind',
    KindName = 'KindName',
    // 目的地點選後的參數
    filterBy = 'filterBy',
    parentId = 'parentId',
    value = 'value',
    text = 'text',
}

/** @summary 將單層資料轉為多層相關資料
 * @param AllData api回傳的陣列
 * @param titleName 分類最上層項目
 * @param titleID 分類最上層id
 * @param childName 分類子項目名稱
 * @param childID 分類子項目id
 * @returns 物件
 */

export function rebuildDestionationData(
    AllData: any[],
    titleName: MutiCheckboxKeys,
    titleID: MutiCheckboxKeys,
    childName: MutiCheckboxKeys,
    childID: MutiCheckboxKeys
) {
    //因obj沒有順序之分，初始的目的地要求要用一開始順序故用Map
    const obj = new Map();
    let i = 0;
    while (i < AllData.length) {
        const ParentID = AllData[i][MutiCheckboxKeys[titleID]];
        if (ParentID !== '') {
            //資料父層沒有parentId則不處理
            if (obj.has(ParentID)) {
                const values = obj.get(ParentID).values;
                obj.set(ParentID, {
                    ParentTitle: AllData[i][MutiCheckboxKeys[titleName]],
                    values: [
                        ...values,
                        {
                            filterBy: AllData[i][MutiCheckboxKeys[titleName]],
                            text: AllData[i][MutiCheckboxKeys[childName]],
                            value: AllData[i][MutiCheckboxKeys[childID]],
                            subValue: '',
                            parentId: ParentID,
                            ChildTitle: AllData[i][MutiCheckboxKeys[childName]],
                            values: AllData[i][MutiCheckboxKeys[childID]],
                            ParentID: ParentID,
                        },
                    ],
                });
            } else {
                obj.set(ParentID, {
                    ParentTitle: AllData[i][MutiCheckboxKeys[titleName]],
                    values: [
                        {
                            filterBy: AllData[i][MutiCheckboxKeys[titleName]],
                            text: AllData[i][MutiCheckboxKeys[childName]],
                            value: AllData[i][MutiCheckboxKeys[childID]],
                            subValue: '',
                            parentId: ParentID,
                            ChildTitle: AllData[i][MutiCheckboxKeys[childName]],
                            values: AllData[i][MutiCheckboxKeys[childID]],
                            ParentID: ParentID,
                        },
                    ],
                });
            }
        }
        i++;
    }
    // Map轉為obj並補上ParentId
    return Array.from(obj, (val) => {
        return {
            ParentId: val[0],
            ...val[1],
        };
    });
}

// 將selectedstore參數資料組成網址字串
export function selectUrl(data: any) {
    let returnStr = '';
    for (let [key, val] of Object.entries(data)) {
        key = key.replace('selected', '');

        if (val instanceof Array) {
            switch (key) {
                case 'Prices': // input滑動 金額
                    val = val.join('-');
                    break;
                case 'ProductTypeID': // 票券 多層篩選 商品類別
                    val = val.map((obj: any) => obj.parentId + '-' + obj.value);
                    break;
                case 'DestinationID': // 多層篩選 目的地
                    val = cityOrCountry(val);
                    break;
                default:
                    val.join(',');
            }
        }
        if (key === 'ProductType' && val instanceof Array && val.length === 0)
            val = 'grp,vac,htl,etk,flt';
        // 所有館別 ProductType無參數時固定帶入所有參數

        returnStr += key + '=' + val + '&'; // ex:params=abc&arg=123
    }
    return returnStr;
}

function cityOrCountry(selectedDest: any[]) {
    if (selectedDest.length === 0) return '';
    // if (Object.keys(allCity).length === 0) return selectedDest.map((obj: any) => obj.value);
    // test start
    let str: string[] = [];
    const Country = new Map();
    const city = selectedDest.map((obj) => {
        if (obj.parentId === obj.value) Country.set(obj.parentId, obj.parentId); //父層在狀態裡會比子層更前面參考元件multicheckbox
        if (!Country.has(obj.parentId)) return obj.value;
        return undefined;
    });
    str = Array.from(Country.values()).concat(city);

    return str.join().replace(/,,+/gi, ',');
}
